import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ProgressComponent } from './progress.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule
    ],
    declarations: [
        ProgressComponent
    ],
    exports: [
        ProgressComponent
    ]
})
export class ProgressModule { }
